import { styled } from '@mui/material';
import clsx from 'clsx';

import {
  IconButton,
  IconButtonProps,
  iconButtonVars,
  tokens,
} from '@cast/design-system';

type HeaderIconButtonProps = {
  active?: boolean;
} & Omit<IconButtonProps, 'size' | 'variant'>;

export const HeaderIconButton = styled(
  ({ className, active, children, ...rest }: HeaderIconButtonProps) => {
    return (
      <IconButton {...rest} className={clsx(className, { active })} size="sm">
        {children}
      </IconButton>
    );
  }
)(() => ({
  ...iconButtonVars.setValues({
    color: tokens.theme.fg.structural.secondary,
    colorHover: tokens.theme.fg.selection.primaryHover,
    colorActive: tokens.theme.fg.selection.primaryHover,
    colorDisabled: tokens.theme.disabled.fg,
    background: 'unset',
    backgroundHover: tokens.theme.bg.action.ghostHover,
    backgroundActive: tokens.theme.bg.action.ghostActive,
    backgroundDisabled: 'unset',
    boxShadowHover: `inset 0 0 0 1px ${tokens.theme.border.action.ghostHover}`,
    boxShadowActive: `inset 0 0 0 1px ${tokens.theme.border.action.ghostActive}`,
    iconSize: '20px',
  }),
}));
